import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

class GroupeSecuriteSelect extends React.Component {
    render() {
        const { value, onChange, groupes } = this.props;

        return (
            <TextField
                select
                name="groupeId"
                label="Groupe de sécurité"
                value={value}
                onChange={onChange}
                fullWidth
            >                
                {groupes.map(groupe => (
                    <MenuItem key={groupe.id} value={groupe.id}>
                        {groupe.libelle}
                    </MenuItem>)
                )}

            </TextField>
        );
    }
}

GroupeSecuriteSelect.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    groupes: PropTypes.array.isRequired
};

export default GroupeSecuriteSelect;